import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core'
import { AssistantFeedback } from '../../../../models/assistantFeedback'
import { User } from 'src/app/models/user'
import { Observable, ReplaySubject, switchMap } from 'rxjs'
import { AssistantFeedbackService } from '../../../../services/domain/assistant-feedback/assistant-feedback.service'
import { tap } from 'rxjs/operators'
import { EditorAssistanceAssignment } from '../../../../models/EditorAssistance'

@Component({
  selector: 'app-assistant-feedback-viewer',
  templateUrl: './assistant-feedback-viewer.component.html',
  styleUrls: ['./assistant-feedback-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None, // To be able to style 'template' element
  standalone: false,
})
export class AssistantFeedbackViewerComponent implements OnChanges {
  @Input() assignments: EditorAssistanceAssignment[]
  @Input() currentUser: User
  @Input() allowRemoveFeedback = false

  private assignmentIds$$ = new ReplaySubject<number[]>()
  protected feedbacks$: Observable<AssistantFeedback[]> = this.assignmentIds$$.pipe(
    tap((e) => console.log('feedback', e)),
    switchMap((assignmentIds) => this.service.getByAssignmentIds(assignmentIds)),
  )

  constructor(private service: AssistantFeedbackService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.assignments && changes.assignments.currentValue) {
      const assignmentIds = changes.assignments.currentValue.map((a: AssistantFeedback) => a.id)
      this.assignmentIds$$.next(assignmentIds)
    }
  }

  async removeFeedback(feedback: AssistantFeedback) {
    console.log(`AssistantFeedbackViewerComponent#removeFeedback:`, feedback)
    await this.service.removeById(feedback.id)
  }
}
